module.exports = __webpack_public_path__ + "img/img4.3099664d.png";